import { API_URL } from "../constants";
import axios from "axios";
import middleware from "../util/middleware";
import { getSegmento } from "../util/generics.js";

var request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
        'x-segmento': getSegmento()
    }
});

/**
 * Clase para ver el request de reportes
 */
export default class ReporteRequest {

    static DiferenciaInventario(filtros) {
        let params = {
            sucursal_id: filtros?.sucursal_id?.toString(),
            drive_id: filtros?.drive_id?.toString(),
            fecha_inicial: filtros?.fecha_inicial,
            fecha_final: filtros?.fecha_final,
            id_tipo_inventario:filtros.id_tipo_inventario,
            id_tipo_diferencia:filtros.id_tipo_diferencia,
            articulo_id:filtros.articulo_id,
            documento:filtros.documento
        }
        // if(filtros.documento){
        //     params.documento = '';
        //     filtros.documento.forEach(element => {
        //         params.documento += `${element}&`
        //     });
        //     params.documento =  params.documento.substring(0,  params.documento.length - 1);
        // }

        return middleware.hasAuth(() => request.post(`reporteDiferenciaInventario`, params));
    }

    static ReporteMerma(filtros) {
        return middleware.hasAuth(() => request.get(`reportemermas`, {
            params: {
                sitio_id: filtros?.drive_id?.toString(),
                inicial: filtros?.fecha_inicial,
                final: filtros?.fecha_final
            }
        }));
    }

    static CierreDia(filtros){
        return middleware.hasAuth(() => request.get(`cierredia`, {
            params: {
                sitio_id: filtros?.drive_id?.toString(),
                inicial: filtros?.dateStrings[0] ?? undefined,
                final: filtros?.dateStrings[1] ?? undefined
            }
        }));
    }

}